import React, { Component } from "react";
import { connect } from "react-redux";
import { Card, Button, Modal } from "react-bootstrap";
import lock from "../../../../assets/img/locks.png";
import toastr from "toastr";
import "./ejercicio.css";
import ReactHlsPlayer from "react-hls-player";
import * as axios from "axios";

class Ejercicio extends Component {
	constructor(props) {
		super(props);
		this.state = {
			width: 768,
			show: false,
			ejercicio: {},
		};
		this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleShow = this.handleShow.bind(this);
	}
	componentDidMount() {
		window.addEventListener("resize", this.updateWindowDimensions());
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.updateWindowDimensions);
	}
	updateWindowDimensions() {
		this.setState({ width: window.innerWidth });
	}
	handleClose() {
		this.setState({ show: false, ejercicio: {} });
	}
	handleShow(ejer) {
		this.setState({ show: true, ejercicio: ejer });
	}
	getVideoId(video) {
		var index = video.indexOf("v=");
		if (index > 0) {
			let id = video.slice(index + 2, index + 2 + 11);
			return id;
		} else {
			index = video.indexOf(".be/");
			let id = video.slice(index + 4, index + 4 + 11);
			return id;
		}
	}
	async copyLink() {
		const text =
			window.location.origin +
			"/ejercicios/#/ejercicio/" +
			this.state.ejercicio.Exercise_Id;
		await navigator.clipboard.writeText(text);
		toastr.clear();
		toastr.options = {
			showDuration: "300",
			hideDuration: "1000",
			timeOut: "5000",
			extendedTimeOut: "1000",
			showEasing: "swing",
			hideEasing: "linear",
			showMethod: "fadeIn",
			hideMethod: "fadeOut",
		};
		toastr.success("Enlace copiado en el portapapeles");
	}
	shareLink() {
		const text =
			window.location.origin +
			"/ejercicios/#/ejercicio/" +
			this.state.ejercicio.Exercise_Id;
		navigator.share({ url: text });
	}

	render() {
		return (
			<>
				<Modal size='xl' show={this.state.show} onHide={this.handleClose}>
					<Modal.Header id='ejercicio-modal-header' closeButton></Modal.Header>

					<Modal.Body>
						<div className='container'>
							<div className='row'>
								<div className='col-12 col-lg-6'>
									<div>
										<ReactHlsPlayer
											src={this.state.ejercicio.video_src}
											autoPlay={false}
											controls={true}
											width='100%'
											height='auto'
										/>
									</div>

									<div
										className='row'
										style={{ justifyContent: "center", padding: "0px 15px" }}
									>
										{this.state.ejercicio.Larg_Img_1 &&
										this.state.ejercicio.Larg_Img_1.includes("images") ? (
											<img
												src={this.state.ejercicio.Larg_Img_1}
												alt='exercice_1'
												className='exercice_image'
												style={{ paddingLeft: "0px", paddingRight: ".2rem" }}
											></img>
										) : null}
										{this.state.ejercicio.Larg_Img_2 &&
										this.state.ejercicio.Larg_Img_2.includes("images") ? (
											<img
												src={this.state.ejercicio.Larg_Img_2}
												alt='exercice_2'
												className='exercice_image'
												style={{ paddingRight: "0px", paddingLeft: ".2rem" }}
											></img>
										) : null}
									</div>
								</div>

								<div className='col-12 col-lg-6'>
									<h4 style={{ margin: "1rem 0px" }}>
										{this.state.ejercicio.Exercise_Name_Complete}
									</h4>
									<Card.Subtitle
										className='mb-2 text-muted'
										style={{ textTransform: "capitalize" }}
									>
										<b>Músculo:</b> {this.state.ejercicio.Target_Muscle_Group}
									</Card.Subtitle>
									<Card.Subtitle
										className=' text-muted'
										style={{
											textTransform: "capitalize",
											marginBottom: "1rem",
										}}
									>
										<b>Implementos:</b>{" "}
										{this.state.ejercicio.Apparatus_Groups_Name}
									</Card.Subtitle>
									<Button
										className='pdfprint'
										onClick={() =>
											this.props.addToPlan(
												this.state.ejercicio,
												this.props.dayIndex
											)
										}
									>
										<i className='fas fa-plus'></i>Añadir a mi rutina
									</Button>
									<div style={{ marginTop: "1rem" }}>
										<h6>Preparación</h6>
										<p>{this.state.ejercicio.Instructions_Preparation}</p>
									</div>
									<div>
										<h6>Ejecución</h6>
										<p>{this.state.ejercicio.Instructions_Execution}</p>
									</div>
									<div
										style={{ display: "flex", justifyContent: "space-between" }}
									>
										<div className='copyLink' onClick={() => this.copyLink()}>
											<i className='fas fa-link'></i> Copiar enlace
										</div>
										<div className='copyLink' onClick={() => this.shareLink()}>
											<i class='fas fa-share-alt'></i> Compartir ejercicio
										</div>
									</div>
								</div>
							</div>

							<div>
								{/* <label style={{ marginTop: '20px', color: 'gray' }}>Tambien podria interesarte</label> */}
							</div>
						</div>
					</Modal.Body>
				</Modal>

				<div
					className='content-ejercicio col-12 col-lg-4'
					style={{ marginBottom: "20px" }}
				>
					<Card className='card-ejercicio'>
						{/*   <div className="playyoutube">
              <img
                src={play}
                alt="btnplay"
                onClick={() => this.handleShow(this.props.ejercicio)}
              ></img>
            </div> */}
						<Card.Img
							variant='top'
							src={
								"https:" +
								(this.props.ejercicio.Recommend_Image === 1
									? this.props.ejercicio.Larg_Img_1
									: this.props.ejercicio.Larg_Img_2)
							}
							alt='ejercicio'
							style={{ zIndex: "2" }}
							onClick={() => this.handleShow(this.props.ejercicio)}
						/>

						<Card.Body onClick={() => this.handleShow(this.props.ejercicio)}>
							{/* <div>
                {this.state.width > 767
                  ? {
                      <StarRatings
                    rating={this.props.ejercicio.rating}
                    starRatedColor='rgb(255, 200, 0)'
                    starDimension='20px'
                    starSpacing='3px'
                    numberOfStars={5}
                    name='rating'
                  />
                    }
                  : null}
              </div> */}
							<div className='cardtitle' style={{ zIndex: "100" }}>
								<Card.Title>
									{this.props.ejercicio.Exercise_Name_Complete}
								</Card.Title>
							</div>
							<Card.Subtitle
								className='mb-2 text-muted'
								style={{ textTransform: "capitalize" }}
							>
								{this.state.width > 767 ? <b>Músculo:</b> : null}{" "}
								{this.props.ejercicio.Target_Muscle_Group}
							</Card.Subtitle>
							<Card.Subtitle
								className='mb-2 text-muted'
								style={{ textTransform: "capitalize" }}
							>
								{this.state.width > 767 ? <b>Implementos:</b> : null}{" "}
								{this.props.ejercicio.Apparatus_Name}
							</Card.Subtitle>
						</Card.Body>

						<div className='add-ejercice'>
							{/*  {this.state.width < 767 ? (
                <div className="star2">
                  { <label
                    style={{
                      marginBottom: '0',
                      paddingRight: '5px',
                      fontWeight: '700'
                    }}>
                    {this.props.ejercicio.rating}
                  </label>}
                  <i className="fas fa-star"></i>
                </div>
              ) : null} */}
							<Button
								style={{ zIndex: "5" }}
								onClick={() =>
									this.props.addToPlan(
										this.props.ejercicio,
										this.props.dayIndex
									)
								}
							>
								<i className='fas fa-plus'></i>
							</Button>
						</div>
					</Card>
				</div>
			</>
		);
	}
}

const setDay = (i) => {
	switch (i) {
		case 1:
			return "Lunes";
		case 2:
			return "Martes";
		case 3:
			return "Miercoles";
		case 4:
			return "Jueves";
		case 5:
			return "Viernes";
		case 6:
			return "Sabado";
		case 7:
			return "Domingo";
		default:
			return "Lunes";
	}
};
const mapStateToProps = (state) => ({
	dayIndex: state.dayIndex,
	personalPlan: state.personalPlan,
	userRestricId: state.userRestricId,
});
const mapDispatchToProps = (dispatch) => ({
	addToPlan(ejercice, day) {
		toastr.clear();
		toastr.options = {
			showDuration: "300",
			hideDuration: "1000",
			timeOut: "5000",
			extendedTimeOut: "1000",
			showEasing: "swing",
			hideEasing: "linear",
			showMethod: "fadeIn",
			hideMethod: "fadeOut",
		};
		toastr.success(
			ejercice.Exercise_Name_Complete +
				" agregado a tu rutina en el dia " +
				setDay(day + 1)
		);

		dispatch({
			type: "ADD_EJERCICIO",
			ejercice: {
				...ejercice,
				muscle: "",
				sets: 1,
				reps: 1,
			},
		});
	},
});
export default connect(mapStateToProps, mapDispatchToProps)(Ejercicio);
